import WxConfig from './wxconfig'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
class WxSdks {
  // 微信扫一扫
  static scanQR = () => {
    this.show = true
    // Toast.loading({
    //   message: '正在发起收款...',
    //   forbidClick: true,
    //   duration: 0
    // })
    if (tuhu.device.isWeixin) {
      WxConfig.share(['scanQRCode']).then((status) => {
      // console.log('配置是否成功', status)
            wx.scanQRCode({
              desc: 'scanQRCode desc',
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                  let result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                  // tuhu.navigateTo({
                  //   url: '/pages/verifyCode/index',
                  //   data: {
                  //     verifyCode: result
                  //   },
                  //   query: {
                  //     success: 1
                  //   }
                  // })
                },
                fail: function (err) {
				          tuhu.toast(err || '网络错误')
                }
            })
      })
    } else {
      // tuhu.toast('请在微信客户端打开')
    }
  }
  static hideBtn = () => {
    if (tuhu.device.isWeixin) {
      WxConfig.share(['hideMenuItems']).then((status) => {
      console.log('配置是否', status)
        wx.hideMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
          })
      })
    } else {
      tuhu.toast('请在微信客户端打开')
    }
  }
}

export default WxSdks



// WEBPACK FOOTER //
// ./lib/commons/shopWxsdk.js